import { useEffect, useCallback } from 'react';
import { useTracking } from '@folklore/tracking';

export { useTracking };

const useTrackingWithCustomDimensions = (page, { isDisabled = true } = {}) => {
    const tracking = useTracking();
    useEffect(() => {
        if (page !== null && !isDisabled) {
            const {
                metadata: { customDimensions },
            } = page;
            tracking.trackPageViewWithCustomDimensions(customDimensions);
        }
    }, [tracking, page, isDisabled]);
};

export const useImagePixels = (urls) => {
    const tracking = useTracking();
    useEffect(() => {
        if (urls !== null) {
            urls.forEach((url) => {
                tracking.loadImagePixel(url);
            });
        }
    }, [tracking, (urls || []).sort().join(',')]);
};

export const useTrackEvent = () => {
    // const tracking = useTracking();

    const trackEvent = useCallback((category, action, label, value) => {
        if (category !== null && action !== null) {
            // tracking.trackEvent(category, action, label, value);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'eventInteraction',
                eventCategory: category,
                eventAction: action,
                eventLabel: label || null,
                eventValue: value || null,
                debug_mode: true
            });
        }
    }, []);
    return trackEvent;
};

export const useTrackVideo = () => {
    const tracking = useTracking();
    const trackEvent = useCallback((action, video) => {
        tracking.trackVideo(action, video);
    }, []);
    return trackEvent;
};

export const useTrackAd = () => {
    const tracking = useTracking();
    const trackEvent = useCallback((action, slot, renderEvent) => {
        tracking.trackAd(action, slot, renderEvent);
    }, []);
    return trackEvent;
};

export const useTrackLink = () => {
    const tracking = useTracking();
    const trackEvent = useCallback((link, data) => {
        tracking.trackLink(link, data);
    }, []);
    return trackEvent;
};

export default useTrackingWithCustomDimensions;
